import { Component } from '@angular/core';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-welcome-onboarding',
  templateUrl: './welcome-onboarding.component.html',
  styleUrls: ['./welcome-onboarding.component.scss'],
})

/**
 * Welcome image from onboarding screen
 */
export class WelcomeOnboardingComponent {
  RouterKeys = RoutesKeys;
}
